<template>
	<div id="rentabilidadeItens">
		<v-data-table
			:headers="headersRentabilidadeItens"
			:items="listaRentabilidadeItens"
			:fixed-header="true"
			item-key="idpedido"
			:height="380"
			:items-per-page="-1"
			class="elevation-2"
		>
			<template v-slot:item="props">
				<tr
					height="60"
					:style="
						props.item.valor_medio < props.item.custo_unitario
							? 'background: #F8E0E0;color: red;'
							: 'background:#FFF;'
					"
				>
					<td>{{ props.item.idproduto }}</td>
					<td>{{ props.item.descricao_produto }}</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.total_venda_custo
							)
						}}
					</td>
					<td>{{ Helpers.formatarValor(props.item.markup) }}%</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.total_venda
							)
						}}
					</td>
					<td>
						{{ Helpers.formatarValor(props.item.perc_vendas) }}%
					</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.lucro_bruto
							)
						}}
					</td>
					<td>{{ Helpers.formatarValor(props.item.perc_lucro) }}%</td>
					<td>{{ Helpers.formatarValor(props.item.qtde_itens) }}</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.custo_unitario
							)
						}}
					</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.valor_medio
							)
						}}
					</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.valor_unitario
							)
						}}
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import rentabilidadeAPI from "./../../api/rentabilidade";

export default {
	props: ["dadosFornecedor", "atualizarDados"],

	data() {
		return {
			listaRentabilidadeItens: [],
			headersRentabilidadeItens: [
				{ text: "id", value: "idproduto" },
				{ text: "Descrição Produto", value: "descricao_produto" },
				{ text: "Total CMV", value: "total_venda_custo" },
				{ text: "% Markup", value: "markup" },
				{ text: "Total Vendido", value: "total_venda" },
				{ text: "% Venda", value: "perc_vendas" },

				{ text: "Lucro Bruto", value: "lucro_bruto" },
				{ text: "% Lucro Bruto", value: "perc_lucro" },
				{ text: "Qtde. Vendida", value: "qtde_itens" },
				{ text: "Valor Custo", value: "custo_unitario" },
				{ text: "Venda Média", value: "valor_medio" },
				{ text: "Valor Venda", value: "valor_unitario" },
			],
		};
	},

	created() {
		this.buscarRentabilidadeFornecedor();
	},

	watch: {
		atualizarDados() {
			this.buscarRentabilidadeFornecedor();
		},
	},

	methods: {
		buscarRentabilidadeFornecedor() {
			const headers = this.Helpers.iniciarRequisicao();

			const params = {
				grupo: this.dadosFornecedor.grupo,
				filial: this.dadosFornecedor.filial,
				fornecedor: this.dadosFornecedor.idfornecedor,
			};

			this.$store.dispatch(
				"loading/addRequisicao",
				rentabilidadeAPI
					.getRentabilidadeFornecedorItens(headers, params)
					.then((response) => {
						const token = response.data.token;
						localStorage.setItem("token", token);

						this.listaRentabilidadeItens = response.data.produtos;
					})
					.catch(() => {
						this.Helpers.logout();
					})
			);
		},
	},
};
</script>

<style scoped></style>
